import { gql } from "@apollo/client";

export const RESET_PASSWORD = gql`
  mutation CompleteForgotPassword($password: String!) {
    completeForgotPassword(password: $password)
  }
`;
